<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="mini">
            <el-form-item label="零件编码:">
                <el-input size="mini" v-model="dataForm.partCode" placeholder="零件编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="零件名称:">
                <el-input size="mini" v-model="dataForm.partName" placeholder="零件名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="国家:">
                <el-input size="mini" v-model="dataForm.country" placeholder="国家" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item class="fr">
              <el-button size="mini" :loading="saveDisabled" type="primary" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'"  plain @click="save()">
                <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;保存
              </el-button>
                <el-button size="mini" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
<!--                <el-button size="mini" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">-->
<!--                    新建-->
<!--                </el-button>-->
              <el-button size="mini" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addHandleNewRow()" icon="el-icon-plus">
                新增
              </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
          <el-table-edit
              v-model="dataList"
              :columns="['partCode','partName', 'outsourcingSupplier','roundNo'
          ,'country','unitPrice','quantity','summation']"
              ref="editTable"
          >
            <el-table :data="dataList" row-key="id" size="mini" bProject style="width: 100%;" :default-expand-all="false" border :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="partCode" header-align="center" align="left" label="零件编码">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="partCode"
                    >
                      <template slot-scope="{ rowStates }">
                        <span v-show="!rowStates.editing">{{row.partCode}}</span>
                        <el-input
                            size="mini"
                            v-show="rowStates.editing"
                            v-model="row.partCode"
                            clearable
                            placeholder="零件编码"
                        >
                        </el-input>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="partName" header-align="center" align="left" label="零件名称">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="partName"
                    >
                      <template slot-scope="{ rowStates }">
                        <span v-show="!rowStates.editing">{{row.partName}}</span>
                        <el-input
                            size="mini"
                            v-show="rowStates.editing"
                            v-model="row.partName"
                            clearable
                            placeholder="零件名称"
                        >
                        </el-input>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="outsourcingSupplier" header-align="center" align="left" label="外购供应商">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="outsourcingSupplier"
                    >
                      <template slot-scope="{ rowStates }">
                        <span v-show="!rowStates.editing">{{row.outsourcingSupplier}}</span>
                        <el-input
                            size="mini"
                            v-show="rowStates.editing"
                            v-model="row.outsourcingSupplier"
                            clearable
                            placeholder="外购供应商"
                        >
                        </el-input>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="country" header-align="center" align="center" label="国家">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="country"
                    >
                      <template slot-scope="{ rowStates }">
                        <span v-show="!rowStates.editing">{{row.country}}</span>
                        <el-input
                            size="mini"
                            v-show="rowStates.editing"
                            v-model="row.country"
                            clearable
                            placeholder="国家"
                        >
                        </el-input>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="unitPrice" header-align="center" align="right" label="单价(A)元/个">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="unitPrice"
                    >
                      <template slot-scope="{ rowStates }">
                        <span v-show="!rowStates.editing">{{row.unitPrice | digit3}}</span>
                        <ctl-number :precision="3" :min="0"  v-show="rowStates.editing" v-model="row.unitPrice" placeholder="单价(A)元/个"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="quantity" header-align="center" align="right" label="数量(B)">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="quantity"
                    >
                      <template slot-scope="{ rowStates }">
                        <span v-show="!rowStates.editing">{{row.quantity | digit3}}</span>
                        <ctl-number :precision="3" :min="0"  v-show="rowStates.editing" v-model="row.quantity" placeholder="数量(B)"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="summation" header-align="center" align="right" label="合计(C=A*B)元">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="summation"
                    >
                      <template>
                        <span>{{row.unitPrice*row.quantity | digit3}}</span>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="roundNo" width="150" header-align="center" align="right" label="报价轮次">
                </el-table-column>
                <el-table-column header-align="center" align="left" label="操作" width="190">
                    <template slot-scope="scope">
                        <el-button type="text" v-show="scope.row.id !==''"  size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" v-show="scope.row.id !==''"  size="small" :disabled="viewFlag != 'view'? false :true" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" :disabled="viewFlag != 'view'? false :true" @click="deleteHandle(scope.row)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
          </el-table-edit>
            <!-- 分页 -->
            <!-- <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination> -->
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList" @getDataListAll="getDataListAll"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    addPartPrice,
    editPartPrice,
    fetchRfqQuotationOutBuy,
    removeRfqQuotationOutBuy,
    createRfqQuotationOutBuyBatch,
    getQuotationDetail
} from '@/controller/quotation'
import AddOrUpdate from './quotationOutBuy-add-or-update'
import moment from 'moment'
import CtlNumber from '@/views/common/ctl-number'
// require('@/mock/mockContract');
export default {
    props: {
        roundNo: Number,
        dataFromParent: Object
    },
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                partCode: '',
                roundNo:'',
                partName: '',
                country: ''
            },
            viewFlag: '',
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            saveDisabled:false,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    computed: {
      editTable() {
        return this.$refs.editTable
      },
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 265
            }
        }
    },
    components: {
        AddOrUpdate,
      CtlNumber
    },
    filters:{
      digit3:function (data){
          if (data  ==0 ){
            return data
          }
          data = Number(data).toFixed(3)
          if(Number.isNaN(Number(data))){
            return null
        }
        return Number(data)
        },
    },
    // activated() {
    //     this.getDataList()
    // },
    methods: {
      //新一行
      getNewRowData() {
        return {
          'id':'',
          'rfqId': this.dataForm.rfqId,
          'rfqPartId': this.dataForm.rfqPartId,
          'rfqSupplierId': this.dataForm.rfqSupplierId,
          'partCode':'',
          'partName':'',
          'outsourcingSupplier':'',
          'country':'',
          'unitPrice':'',
          'quantity':'',
          'summation':'',
          'roundNo':this.dataForm.roundNo!==null ? this.dataForm.roundNo:'0',
          'rowNum':this.rowNum
        }
      },
      // 新增行
      addHandleNewRow() {
        const newRow = this.getNewRowData()
        this.editTable.newRows([newRow])
        this.rowNum += 1
      },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        // 新增或编辑子节点
        // addChildHandle(id, parentId, parentName, parentNodePath) {

        //     console.log(id, parentId, parentName, parentNodePath)
        //     this.addOrUpdateVisible = true
        //     this.$nextTick(() => {
        //         this.$refs.addOrUpdate.init(null, parentId, parentName, parentNodePath)
        //     })
        // },
        init(rfqId = 0, rfqPartId = 0, supplierId = 0, roundNo = 0, viewFlag) {
            this.dataForm.rfqId = rfqId
            this.dataForm.rfqPartId = rfqPartId
            this.dataForm.rfqSupplierId = supplierId
            this.dataForm.roundNo = roundNo
            this.viewFlag = viewFlag
            this.pageIndex = 1
            this.getDataList()
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            fetchRfqQuotationOutBuy({
                pageNo: 1,
                pageSize: -1,
                ...this.dataForm
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'view', this.dataForm, this.dataFromParent.rfqId)
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'edit', this.dataForm, this.dataFromParent.rfqId)
            })
        },
        // 删除
        deleteHandle(row) {
            if (row.id !== '' ){
              //console.log('5555',row.rfqId)
              if (row && row.rfqId) {
                getQuotationDetail({}, row.rfqId).then(data => {
                  if (data && data.code === '00') {
                    if("2" != data.body.rfqStatus) {
                      this.$message.warning("询价单不是询价中状态，不允许删除报价相关信息")
                    } else {
                        this.$confirm(`确定进行删除操作?`, '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning'
                        }).then(() => {
                          removeRfqQuotationOutBuy({}, row.id).then(data => {
                            if (data && data.code === '00') {
                              this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                  this.getDataList()
                                }
                              })
                              this.$nextTick(() => {
                                  this.getDataListAll();
                              })
                            } else {
                              this.$message.error(data.msg)
                            }
                          })
                        })
                    }
                  }
                })
              }
            }else {
              //未保存的 直接删除行
              // console.log(JSON.stringify(row))
              var a = []
              a.push(row)
              this.editTable.delRows(a)
            }

        },
        fixedNumber(val) {
            if (!val) {
                return 0
            }
            return Number(Number(val).toFixed(3))
        },
        // 获取数据列表
        getDataListAll() {
            this.dataListLoading = true
            fetchRfqQuotationOutBuy({
                pageNo: 1,
                pageSize: -1,
                ...this.dataForm
            }).then(data => {
                console.log(data, 'data')
                if (data && data.code === '00') {
                    this.saveSum(data.body.records)
                } 
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        saveSum(dataListAll){
            let sum = 0;
            if(dataListAll !== 0){
                dataListAll.forEach((item) => {
                    sum += this.fixedNumber(item.summation);
                });
            }
            let params = this.dataFromParent
            params.rfqId = this.dataFromParent.rfqId
            params.outsidePartCost = sum
            // 制造成本小计(D=A+B+C)
            params.productionCostSum = this.fixedNumber(params.materialCost) + this.fixedNumber(params.outsidePartCost) 
                + this.fixedNumber(params.processingCost)
            // 产品单价(J=D+H+I+K+L)
            params.productUnitPrice = this.fixedNumber(params.productionCostSum) + this.fixedNumber(params.midiumCostSum)
                + this.fixedNumber(params.profit) + this.fixedNumber(params.packageFee) 
                + this.fixedNumber(params.transportFee) 
            // 产品价格总计
            params.feeCostSum = this.fixedNumber(params.productUnitPrice) + this.fixedNumber(params.toolsPartAllocation)
                + this.fixedNumber(params.designPartAllocation) 
            if (params.id) {
                editPartPrice(params).then(data => {
                    if (data && data.code === '00') {
                        // this.dataForm.id = data.body.id;
                        // this.dataForm = data.body;
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                        })
                        this.getDataList()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            } else {
                addPartPrice(params).then(data => {
                    if (data && data.code === '00' && data.body) {
                        this.dataFromParent.id = data.body.id;
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                        })

                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        },

      //保存
      save(){
        var ins =[]
        this.dataList.forEach(value => {
          if (value.id ===''){
            ins.push(value)
          }
        })
        if (ins.length > 0 ){
          var params = {
            "list":ins,
            "rfqId": this.dataForm.rfqId,
            "subcompanyId":this.dataFromParent.subcompanyId
          }
          this.saveDisabled = true
          createRfqQuotationOutBuyBatch(params).then(data => {
            if (data && data.code === "00") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 1500,
                });
                this.$nextTick(() => {
                   this.getDataListAll();
                })
              } else {
                this.$message.error(data.msg);
              }
              this.getDataList()
              setTimeout(() => {
                                this.saveDisabled = false
                }, 3000)
              
            })
        }
      },
    }
}
</script>

<style lang="scss">
.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
